<template>
	<div id="cases">
		<header-menu curPage='cases'></header-menu>
		<div class="cases-section" v-if="caseId == 1">
			<img class="icon-cd" src="https://cdn.huimiaokeji.com/hjweb/icon_cd_420.png"/>
			<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/icon_online_earning_300.png"/>
			<div class="title">某网赚类APP</div>
			<div class="description">提供紧密契合的沉浸样式，满足多场景广告需求，同时视频类APP天然适配电商预算场景，可承接更多预算</div>
			<div class="number-box">
				<div class="number-item">
					<div class="number">120%</div>
					<div class="tips">单价提升</div>
				</div>
				<div class="number-item">
					<div class="number">180%</div>
					<div class="tips">收益提升</div>
				</div>
			</div>
			<div class="next-box">
				<img class="next-box-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_upper_page_60.png" @click="toNext(3)"/>
				<img class="next-box-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_next_page_60.png" @click="toNext(2)"/>
			</div>
		</div>
		<div class="cases-section" v-if="caseId == 2">
			<img class="icon-cd" src="https://cdn.huimiaokeji.com/hjweb/icon_cd_420.png"/>
			<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/icon_tool_300.png"/>
			<div class="title">某工具类APP</div>
			<div class="description">独家内容资源帮助提升用户留存，打破“即用即走”魔咒，更多细分行业定制场景助力适配提收</div>
			<div class="number-box">
				<div class="number-item">
					<div class="number">30%</div>
					<div class="tips">单价提升</div>
				</div>
				<div class="number-item">
					<div class="number">25%</div>
					<div class="tips">收益提升</div>
				</div>
			</div>
			<div class="next-box">
				<img class="next-box-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_upper_page_60.png" @click="toNext(1)"/>
				<img class="next-box-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_next_page_60.png" @click="toNext(3)"/>
			</div>
		</div>
		<div class="cases-section" v-if="caseId == 3">
			<img class="icon-cd" src="https://cdn.huimiaokeji.com/hjweb/icon_cd_420.png"/>
			<img class="icon" src="https://cdn.huimiaokeji.com/hjweb/icon_movies_300.png"/>
			<div class="title">某影视类APP</div>
			<div class="description">通过激励视频突破收益天花板，精准买量精细运营，兼顾用户体验与转化</div>
			<div class="number-box">
				<div class="number-item">
					<div class="number">50%</div>
					<div class="tips">单价提升</div>
				</div>
				<div class="number-item">
					<div class="number">100%</div>
					<div class="tips">收益提升</div>
				</div>
			</div>
			<div class="next-box">
				<img class="next-box-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_upper_page_60.png" @click="toNext(2)"/>
				<img class="next-box-icon" src="https://cdn.huimiaokeji.com/hjweb/icon_next_page_60.png" @click="toNext(1)"/>
			</div>
		</div>
		<footer-menu></footer-menu>
	</div>
</template>

<script>
	import HeaderMenu from '../components/header-menu.vue';
	import FooterMenu from '../components/footer-menu.vue';
	export default {
		name:'cases',
		components: {
			HeaderMenu,
			FooterMenu
		},
		data() {
			return {
				caseId: 1
			}
		},
		created() {
		  document.title = '灰鲸网络-合作案例';
		},
		methods: {
			toNext(caseId) {
				this.caseId = caseId;
			}
		}
	}
</script>

<style lang="less">
	#cases {
		background-color: #FFFFFF;
		.cases-section{
			width: 100%;
			height: 820px;
			margin-bottom: 100px;
			background: url(https://cdn.huimiaokeji.com/hjweb/bg_collaboration_cases.jpg) no-repeat;
			background-size: 100% 820px;
			position: relative;
			.icon-cd {
				position: absolute;
				bottom: 120px;
				right: 11.3%;
				width: 420px;
				height: 420px;
			}
			.icon {
				position: absolute;
				bottom: 385px;
				right: 15.5%;
				width: 300px;
				height: 300px;
			}
			.title {
				position: absolute;
				top: 200px;
				left: 120px;
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 34px;
				color: #0B00B5;
				line-height: 34px;
				text-align: left;
				font-style: normal;
			}
			.description {
				position: absolute;
				top: 314px;
				left: 120px;
				width: 600px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 18px;
				color: #333333;
				line-height: 30px;
				text-align: justify;
				font-style: normal;
			}
			.number-box {
				position: absolute;
				top: 404px;
				left: 120px;
				display: flex;
				width: 424px;
				.number-item {
					flex: 1;
					.number {
						font-family: DingTalk, DingTalk;
						font-weight: normal;
						font-size: 40px;
						color: #5511FF;
						line-height: 40px;
						text-align: left;
						font-style: normal;
					}
					.tips {
						margin-top: 20px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 16px;
						color: #3E5979;
						line-height: 16px;
						text-align: left;
						font-style: normal;
					}
				}
			}
			.next-box {
				width: 100%;
				position: absolute;
				height: 60px;
				left: 120px;
				bottom: 200px;
				display: flex;
				.next-box-icon {
					width: 60px;
					height: 60px;
					margin-right: 40px;
					cursor: pointer;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Cases.vue